const UA = {
  ibanLength: 29,
};
export { UA };
